var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "contact-cell",
      on: {
        mouseenter: function ($event) {
          _vm.showMenu = true
        },
        mouseleave: _vm.hideMenu,
      },
    },
    [
      _vm.contact
        ? _c(
            "div",
            {
              staticClass: "contact-info",
              on: {
                click: function ($event) {
                  return _vm.viewContactProfile(_vm.contact)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "contact-avatar" },
                [
                  _c("PlatformIconViewer", {
                    attrs: { platform: _vm.contact.platform },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "contact-name" }, [
                _vm._v(_vm._s(_vm.contact.fullname)),
              ]),
            ]
          )
        : _c(
            "PermissionController",
            { attrs: { permissions: ["table.update"] } },
            [
              _c("a", { on: { click: _vm.showContactPicker } }, [
                _vm._v("+ Kişi Ekle"),
              ]),
            ]
          ),
      _vm._v(" "),
      _vm.showMenu && _vm.contact
        ? _c(
            "div",
            {
              staticClass: "contact-menu",
              on: { mouseenter: _vm.cancelHide, mouseleave: _vm.hideMenu },
            },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("SupsisButton", {
                    attrs: { icon: "edit", xxsmall: "" },
                    on: { click: _vm.editContact },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("SupsisButton", {
                    attrs: { icon: "delete", xxsmall: "" },
                    on: { click: _vm.removeContact },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Kişi Seç",
                okText: "Kaydet",
                xlarge: "",
                className: "contact-picker-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeModal },
            },
            [
              _c("List", {
                attrs: { "picker-mode": "" },
                on: { select: _vm.onContactSelected },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }